import { v4 as uuidv4 } from 'uuid'

export enum ROUTE_PATH {
  SETUP = '/setup',
  LOGIN = '/login',
  VERIFY_OTP = '/verify-otp',
  RESET_PASSWORD = '/reset-password',
  FORGOT_PASSWORD = '/forgot-password',
  TOURNAMENT_DETAIL = '/tournament-detail/:id',
  OVERVIEW = '/overview',
  MANAGE_ADS = '/manage-ads',
  MANAGE_CLB = '/manage-clubs',
  MANAGE_TOURS = '/manage-tours',
  MANAGE_ADMIN = '/manage-admins',
  MANAGE_IMAGES = '/manage-images',
  MANAGE_BANNER = '/manage-banner',
  MANAGE_CADDIE = '/manage-caddie',
  MANAGE_REGISTERS = '/manage-registers',
  MANAGE_COUNTRIES = '/manage-countries',
  MANAGE_TOURNAMENT = '/manage-tournament',
  MANAGE_GOLF_COURSE = '/manage-golf-courses',
  MANAGE_ORGANIZATIONS = '/manage-organizations',
  MANAGE_SPECIFICATION = '/manage-specifications/:id',

  DEFAULT = '/',
  NOT_FOUND = '*'
}

export const enum STORAGE_KEYS {
  VERSION = 'version'
}

export const enum MAX_SIZE_FILE {
  IMAGE = 1024 * 1024 * 5
}

export const enum TYPE_ORGANIZATION {
  GOLF_COURSE = '1',
  EVENT = '2'
}

export const enum GENDER {
  MALE = '1',
  FEMALE = '0'
}
export const enum TYPE_ADMIN {
  SUPER_ADMIN = '3', // anh Phúc - TK có quyền truy cập vào toàn bộ cơ sở dữ liệu của các giải đấu và các dữ liệu liên quan
  // như dữ liệu sân, clb, quốc gia...
  MASTER_ADMIN = '4', // nhật - TK có toàn quyền của super admin - giám sát hệ thống, xử lý sự cố
  GOLF_COURSE_ADMIN = '1', // admin sân đấu cụ thể, địa chỉ cụ thể, do admin orgainization tạo ra. Ví dụ như FLC Sầm Sơn,
  // FLC Hà Nội, FLC Vũng Tàu...
  EVENT_ADMIN = '2' // admin sự kiện. Ví dụ như VGEvent, HN Junior, các CLB...
}

export enum TEES {
  RED = 'red',
  BLUE = 'blue',
  GOLD = 'gold',
  GRAY = 'gray',
  WHITE = 'white',
  BLACK = 'black',
  SILVER = 'silver',
  ORANGE = 'orange'
}

export const enum TYPE_TOURNAMENT {
  STROKE_PLAY = 'STROKE_PLAY',
  MATCH_PLAY = 'MATCH_PLAY',
  MATCH_PLAY_CLUB = 'MATCH_PLAY_CLUB'
}

export const enum COLORS {
  PRIMARY = '#16533D',
  SECONDARY = '#FFFFFF'
}

export const enum LOCATIONS_ADVERTISING {
  BANNER_HOMEPAGE = 'BANNER_HOMEPAGE'
}

export const KEY_EVENT_MESSAGE = uuidv4()

export const enum STATUS_GOFLER {
  NORMAL = 0,
  WITHDRAW = 1,
  RETD = 2,
  OUT_CUT = 3,
  DISQUALIFIED = 4
}

export const enum LEVEL_GOLFER {
  NONE = 0,
  AMATEUR = 2,
  PROFESSIONAL = 1
}

export const enum SCORING_TYPE {
  NONE = 0,
  STANDARD_NET = 1,
  SYSTEM36 = 2,
  PEORIA_SYSTEM = 3,
  DOUBLE_PEORIA = 4
}

export enum RANKING_GOLFER {
	NONE = 0,
	CHAMPOIN = 1
}
